import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { attributesFromSchema } from '../../../lib';
import { AttributeList } from '../../attribute-list';
import { SchemaDescription } from './SchemaDescription';
import { SchemaEnumValues } from './SchemaEnumValues';
import { SchemaValidationBadges } from './SchemaValidationBadges';
export function SchemaView({ schema }) {
    if (typeof schema === 'boolean') {
        return (_jsx("div", { className: "rounded-lg border border-zinc-950/10 bg-transparent bg-zinc-50 dark:border-white/20 dark:bg-white/5", children: _jsxs("p", { className: "p-2 text-xs", children: [schema && _jsx("span", { children: "any data" }), !schema && _jsx("span", { children: "no data" })] }) }));
    }
    if (typeof schema !== 'object' || schema === null) {
        return null;
    }
    // Since these docs are not editable, don't need to display empty child attributes
    const hasAttributes = attributesFromSchema(schema).attributes.length > 0;
    if (!hasAttributes) {
        return (_jsx("div", { className: "rounded-lg border border-zinc-950/10 bg-transparent bg-zinc-50 dark:border-white/20 dark:bg-white/5", children: _jsxs("div", { className: "space-y-2 px-2 py-2", children: [_jsx(SchemaValidationBadges, { schema: schema }), _jsx(SchemaDescription, { schema: schema }), _jsx(SchemaEnumValues, { schema: schema })] }) }));
    }
    return (_jsx("div", { className: "space-y-2", children: _jsx("div", { className: clsx('rounded-lg border border-zinc-950/10 bg-transparent bg-zinc-50 [--gutter:theme(spacing.2)] dark:border-white/20 dark:bg-white/5'), children: _jsx(AttributeList, { schema: schema, parents: [] }) }) }));
}
